import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'egift-card-resend-form';

export default dynaForms.getTypes(storeName);
